export default __webpack_public_path__ + "static/thehub-lg-da04d689855e8737a1d5f3f960fbe6ac.png";